/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type UpsertDiscoveryProfileMutationVariables = Types.Exact<{
  stage_slug: Types.Scalars["String"];
  name?: Types.Maybe<Types.Scalars["String"]>;
  pronouns?: Types.Maybe<
    Array<Types.Scalars["String"]> | Types.Scalars["String"]
  >;
  profile_photo?: Types.Maybe<
    Array<Types.Scalars["Int"]> | Types.Scalars["Int"]
  >;
  profile_photo_caption?: Types.Maybe<Types.Scalars["String"]>;
  profile_photo_upload?: Types.Maybe<Types.Scalars["Upload"]>;
  bio_prompt?: Types.Maybe<Types.Scalars["String"]>;
  bio?: Types.Maybe<Types.Scalars["String"]>;
  interests?: Types.Maybe<
    Array<Types.Scalars["String"]> | Types.Scalars["String"]
  >;
  experience_goals?: Types.Maybe<Types.Scalars["String"]>;
  weekend_pace?: Types.Maybe<Types.Scalars["Int"]>;
  skills?: Types.Maybe<
    Array<Types.Scalars["String"]> | Types.Scalars["String"]
  >;
  teammates_needed?: Types.Maybe<Types.Scalars["Int"]>;
  teammate_criteria?: Types.Maybe<Types.Scalars["String"]>;
  teammates_claim_ids?: Types.Maybe<
    Array<Types.Scalars["String"]> | Types.Scalars["String"]
  >;
  contact_discord?: Types.Maybe<Types.Scalars["String"]>;
  contact_linkedin?: Types.Maybe<Types.Scalars["String"]>;
  contact_x?: Types.Maybe<Types.Scalars["String"]>;
}>;

export type UpsertDiscoveryProfileMutation = {
  upsertDiscoveryProfile: Pick<Types.Claim, "id"> & {
    stage: Pick<Types.Stage, "slug">;
  };
};

export const UpsertDiscoveryProfileDocument = gql`
  mutation UpsertDiscoveryProfile(
    $stage_slug: String!
    $name: String
    $pronouns: [String!]
    $profile_photo: [Int!]
    $profile_photo_caption: String
    $profile_photo_upload: Upload
    $bio_prompt: String
    $bio: String
    $interests: [String!]
    $experience_goals: String
    $weekend_pace: Int
    $skills: [String!]
    $teammates_needed: Int
    $teammate_criteria: String
    $teammates_claim_ids: [String!]
    $contact_discord: String
    $contact_linkedin: String
    $contact_x: String
  ) {
    upsertDiscoveryProfile(
      stage_slug: $stage_slug
      name: $name
      pronouns: $pronouns
      profile_photo: $profile_photo
      profile_photo_caption: $profile_photo_caption
      profile_photo_upload: $profile_photo_upload
      bio_prompt: $bio_prompt
      bio: $bio
      interests: $interests
      experience_goals: $experience_goals
      weekend_pace: $weekend_pace
      skills: $skills
      teammates_needed: $teammates_needed
      teammate_criteria: $teammate_criteria
      teammates_claim_ids: $teammates_claim_ids
      contact_discord: $contact_discord
      contact_linkedin: $contact_linkedin
      contact_x: $contact_x
    ) {
      id
      stage {
        slug
      }
    }
  }
`;

/**
 * __useUpsertDiscoveryProfileMutation__
 *
 * To run a mutation, you first call `useUpsertDiscoveryProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDiscoveryProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDiscoveryProfileMutation, { data, loading, error }] = useUpsertDiscoveryProfileMutation({
 *   variables: {
 *      stage_slug: // value for 'stage_slug'
 *      name: // value for 'name'
 *      pronouns: // value for 'pronouns'
 *      profile_photo: // value for 'profile_photo'
 *      profile_photo_caption: // value for 'profile_photo_caption'
 *      profile_photo_upload: // value for 'profile_photo_upload'
 *      bio_prompt: // value for 'bio_prompt'
 *      bio: // value for 'bio'
 *      interests: // value for 'interests'
 *      experience_goals: // value for 'experience_goals'
 *      weekend_pace: // value for 'weekend_pace'
 *      skills: // value for 'skills'
 *      teammates_needed: // value for 'teammates_needed'
 *      teammate_criteria: // value for 'teammate_criteria'
 *      teammates_claim_ids: // value for 'teammates_claim_ids'
 *      contact_discord: // value for 'contact_discord'
 *      contact_linkedin: // value for 'contact_linkedin'
 *      contact_x: // value for 'contact_x'
 *   },
 * });
 */
export function useUpsertDiscoveryProfileMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpsertDiscoveryProfileMutation,
    UpsertDiscoveryProfileMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    UpsertDiscoveryProfileMutation,
    UpsertDiscoveryProfileMutationVariables
  >(UpsertDiscoveryProfileDocument, baseOptions);
}
export type UpsertDiscoveryProfileMutationHookResult = ReturnType<
  typeof useUpsertDiscoveryProfileMutation
>;
export type UpsertDiscoveryProfileMutationResult =
  ApolloReactCommon.MutationResult<UpsertDiscoveryProfileMutation>;
export type UpsertDiscoveryProfileMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpsertDiscoveryProfileMutation,
    UpsertDiscoveryProfileMutationVariables
  >;
